export namespace FeaturesModuleTest {
  export class Configurator implements Persistance {
    billingAddress: boolean;

    constructor(persistance?: Persistance) {
      this.billingAddress = persistance?.billingAddress ?? false;
    }
  }

  export interface Persistance {
    billingAddress: boolean;
  }
}
